import type { Vacancy } from '@/clients/AutoCompleteClient/types';
import type { Candidate } from 'model';

export type RJCommunicationHubProps = {
  candidate: Candidate;
  initialVacancy?: Vacancy;
};

export enum ModalState {
  NONE = 'NONE',
  ACTIVATE_ROBIN_JR = 'ACTIVATE_ROBIN_JR',
  GENERATED_MESSAGE = 'GENERATED_MESSAGE',
  QUESTIONNAIRE_PREVIEW = 'QUESTIONNAIRE_PREVIEW',
  WHATSAPP = 'WHATSAPP',
  LOADING = 'LOADING',
  LOADING_GENERATED_MESSAGE = 'LOADING_GENERATED_MESSAGE',
}
